import { render, staticRenderFns } from "./TradeMarketplaceSellerList.vue?vue&type=template&id=c6018edc&"
import script from "./TradeMarketplaceSellerList.vue?vue&type=script&lang=js&"
export * from "./TradeMarketplaceSellerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports